import * as React from "react";
import styled from "styled-components";
import { clientConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../../../config/styles_const/styles_const";
import { Client } from "../../../../../domain/model/client";
import AvatarMiddle from "../../../../common/atom/avatar/avatar_middle";
import BadgeBorder from "../../../../common/atom/badge/badge_border";
import BtnCancelSmall from "../../../../common/atom/btn/btn_cancel_small";
import LabelJob from "../../../../common/atom/label/label_job";
import HeadlineMiddle from "../../../../common/atom/text/headline_middle";
import ParagraphSup from "../../../../common/atom/text/paragraph_sup";

interface IProps {
  client: Client;
  handleClickModalOpen?: (e: any) => void;
}

const MemberProfile: React.FC<IProps> = (props) => {
  const { client, handleClickModalOpen } = props;

  return (
    <Wrapper>
      <MainContents>
        <AvatarWrapper>
          <AvatarMiddle src={client.getIconURL()} />
        </AvatarWrapper>
        <Inner>
          <Flex>
            {client.department && <Position>{client.department}</Position>}
            {client.position && <Position>{client.position}</Position>}
          </Flex>
        </Inner>
        <Inner>
          <ParagraphSup bold={true}>{client.nameKana}</ParagraphSup>
          <HeadlineMiddle>{client.name}</HeadlineMiddle>
        </Inner>
        <EmailWrapper>
          <EmailParagraphSup bold={true}>{client.email}</EmailParagraphSup>
        </EmailWrapper>
        <RoleBadgeWrapper>
          <RoleBadge>{clientConfig.roleList.get(client.role)}</RoleBadge>
        </RoleBadgeWrapper>
      </MainContents>
      {handleClickModalOpen && (
        <BtnWrapper>
          <BtnCancelSmall onClick={handleClickModalOpen} value={client.id}>
            権限の変更・削除
          </BtnCancelSmall>
        </BtnWrapper>
      )}
    </Wrapper>
  );
};

export default MemberProfile;

const Wrapper = styled.div`
  margin: 40px 0;
  border: 1px solid ${ConstColor.PlaceholderAndBorder};
  border-radius: ${ConstBorderRound.CornerRoundAll};
  text-align: center;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  @media (min-width: ${ConstBreakPoint.Default}) {
    width: 45%;
  }
  @media (min-width: ${ConstBreakPoint.PcDeskTop}) {
    width: 30%;
  }
`;

const MainContents = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

const AvatarWrapper = styled.div`
  margin-bottom: 20px;
`;

const Inner = styled.div`
  margin: 10px 0;
`;

const Position = styled(LabelJob)`
  margin-right: 10px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmailWrapper = styled.div`
  margin-bottom: 20px;
`;

const EmailParagraphSup = styled(ParagraphSup)`
  color: ${ConstColor.Gray};
`;

const RoleBadgeWrapper = styled.div`
  margin-bottom: 20px;
`;

const RoleBadge = styled(BadgeBorder)`
  background-color: ${ConstColor.Corporate};
  color: ${ConstColor.White};
`;

const BtnWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px dashed ${ConstColor.PlaceholderAndBorder};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/info_clients/member_profile.tsx